import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Chevron: FC<IconSvgProps> = ({ color, clss }) => {
    return (
        <svg className={clss} width="22" height="22" viewBox="0 0 22 22" focusable="false" aria-hidden="true">
            <g fill="none" fillRule="evenodd">
                <g fill={color}>
                    <path
                        d="M5.852 14.792l4.784-4.818 4.816 4.818c.642.66 1.734-.41 1.092-1.071l-5.458-5.48c-.225-.22-.643-.251-.867-.03L4.76 13.72c-.642.661.45 1.732 1.091 1.07z"
                        transform="translate(-270 -201) translate(29 171) translate(0 30) translate(241) matrix(1 0 0 -1 0 23.06)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Chevron;
